import { render, staticRenderFns } from "./Error403.vue?vue&type=template&id=54fe048b&scoped=true&"
import script from "./Error403.vue?vue&type=script&lang=js&"
export * from "./Error403.vue?vue&type=script&lang=js&"
import style0 from "./Error403.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Error403.vue?vue&type=style&index=1&id=54fe048b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe048b",
  null
  
)

export default component.exports